import makeStyles from '@mui/styles/makeStyles';
import { green } from '@mui/material/colors';

export const JourneyClasses = makeStyles((theme) => ({
    contactButtonIcon: {
        height: 15
    },
    infoText: {
        textTransform: 'capitalize',
        lineHeight: 1.5
    },
    block: {
        padding: 16,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    stepTtile:{
        fontSize: 20, 
        fontWeight: 500, 
        //fontFamily: `'Inter', sans-serif`, 
        lineHeight: '28px', 
        marginBottom: 8
    },
    stepText: {
        color: '#4b5563',
        fontSize: 16,
        lineHeight: '20px',
        marginBottom: 16
    },
    stepButton: {
        textTransform: 'capitalize',
        padding: '12px 24px',
        width: '100%',
        fontWeight: 500,
        fontSize: 16,
        borderRadius: 8
    },
    stepBadgeContainer: {
        //textAlign: 'center',
        margin: '0 auto 16px'
    },
    stepBadge: {
        width: 48,
        height: 48,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        borderRadius: '100%',
        fontSize: 18,
        fontWeight: 700,
        lineHeight: '28px'
    },
    stepPicture: {
        width: '128px',
        height: '128px',
        margin: '0 auto 24px'
    },
    stepImg: {
        width: '100%',
        borderRadius: 8
    },
    stepCompleted: {
        backgroundColor: green[400] + ' !important'
    },
    cvclTag: {
        display: 'flex',
        justifyContent: 'space-between',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        borderRadius: 8,
        borderStyle: 'solid',
        padding: 16,
        marginBottom: 12,
        alignItems: 'center'
    },
    cvclTagActive: {
        backgroundColor: '#6366f10d',
        borderColor: '#6366f133'
    },
    blockButton: {
        padding: 16,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #e5e7eb', 
        marginBottom: 4, 
        borderRadius: 8,
        transitionProperty: 'box-shadow',
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
        transitionDuration: '150ms',
        '&:hover': {
            boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'
        },
    },
    tableAvatar: {
        width: 32, 
        height: 32, 
        padding: 14,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '100%',
        marginRight: 12,
    }
}));